module.exports = __webpack_public_path__ + "media/images/icons/credit_card/diners-82815226b9bf8c52bf4caf819d728b76.svg";